
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prohibited_item",
      function () {
        return require("private-next-pages/prohibited_item.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prohibited_item"])
      });
    }
  